package org.hs_soft.runmynesto.domain.usecase.product.tab_price

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.SpecialPriceModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.GetSpecialPriceRepository
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_price.UpdateSpecialPriceRepository

class UpdateSpecialPriceUseCase(
    private val repository: UpdateSpecialPriceRepository
) {
    suspend operator fun invoke(
        id:String,
        title:String,
        value:dynamic
    ):SpecialPriceModel {
        return repository.updateSpecialPrice(
            id=id,
            title=title,
            value = value,
        )
    }


}